var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencilSection = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit/24x24/ultradark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit/24x24/ultradark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3698783,2.484 L2.44883478,16.3476522 C2.45196522,16.356 2.45092174,16.3653913 2.44883478,16.3737391 L7.62448696,21.5493913 L7.62657391,21.5493913 C7.63492174,21.5493913 7.64222609,21.5514783 7.64848696,21.5556522 L21.5737043,7.68678261 L16.3698783,2.484 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44090435,16.3661217 C2.43881739,16.3629913 2.43464348,16.3640348 2.4336,16.3671652 L0.5376,22.7271652 C0.4896,22.9327304 0.551165217,23.1497739 0.701426087,23.2989913 C0.850643478,23.4482087 1.06664348,23.5108174 1.2722087,23.4628174 L7.62386087,21.5689043 C7.63116522,21.5668174 7.63325217,21.5584696 7.62803478,21.5532522 L2.44090435,16.3661217 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5736,7.6872 L22.3833391,6.82006957 C23.323513,5.89241739 23.6939478,4.5338087 23.3548174,3.2565913 C23.015687,1.98041739 22.0191652,0.983895652 20.7429913,0.644765217 C19.4668174,0.306678261 18.1071652,0.677113043 17.179513,1.61728696 L16.3697739,2.48441739 L21.5736,7.6872 Z",
    id: "Stroke-5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencilSection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil_section.cfcaeafc66548e53bea7fa91027b988c.svg";